(function () {
  function revealAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.floral-rise').forEach((el) => {
      if (!el || !el.classList) return;
      el.classList.add('is-inview');
      el.style.willChange = '';
    });
  }

  const failsafe = setTimeout(function () {
    revealAll(document);
  }, 3000);

  try {
    const html = document.documentElement;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopMq = window.matchMedia('(min-width: 990px)');
    const isDesignMode = Boolean(window.Shopify && Shopify.designMode);
    const motionOn = html.classList.contains('floral-motion-on');
    const smoothOn = html.classList.contains('floral-smooth');
    const staggerCap = 8;
    const parallaxClamp = 24;
    const overlayPrevent =
      '[data-floral-no-lenis], [data-lenis-prevent], dialog, .cardraw, .js-mini-cart, .menu-natur, .side-menu__wrap, .mini-cart-content';

    let observer = null;
    let lenis = null;
    let parallaxNodes = [];
    let parallaxActive = false;
    let measureTimer = 0;
    let overlayLocked = false;
    let overlayLockBound = false;

    function prefersReduce() {
      return reduceMotion.matches;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function tagLegacyRises(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.template-collection .grid, .template-search .grid, .template-product .product-single__meta').forEach((container) => {
        if (container.closest('.swiper-container, .swiper')) return;
        container.setAttribute('data-floral-stagger', '');
      });
      scope.querySelectorAll('.template-collection .grid > .grid__item, .template-search .grid > .grid__item, .template-product .product-single__meta > .product-block').forEach((el) => {
        if (el.closest('.swiper-container, .swiper-wrapper')) return;
        el.classList.add('floral-rise');
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('is-inview');
        }
      });
    }

    function assignStagger(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-floral-stagger]').forEach((container) => {
        container.querySelectorAll(':scope > .floral-rise').forEach((el, index) => {
          el.style.setProperty('--floral-rise-order', String(Math.min(index, staggerCap)));
        });
      });
    }

    function reveal(el) {
      if (!el || !el.classList) return;
      el.classList.add('is-inview');
      el.style.willChange = '';
    }

    function isUnobservable(el) {
      return el.offsetParent === null && getComputedStyle(el).position !== 'fixed';
    }

    function observeCarousel(carousel) {
      const cells = carousel.querySelectorAll('[data-carousel-track] > .floral-rise');
      if (!cells.length) return;
      if (carousel.classList.contains('is-inview')) return;
      if (isUnobservable(carousel)) {
        cells.forEach(reveal);
        return;
      }
      cells.forEach((el) => {
        el.style.willChange = 'opacity, transform';
      });
      observer.observe(carousel);
    }

    function observeRises(root) {
      if (!observer) return;
      const scope = root && root.querySelectorAll ? root : document;
      if (scope.matches && scope.matches('floral-carousel')) {
        observeCarousel(scope);
      } else {
        scope.querySelectorAll('floral-carousel').forEach(observeCarousel);
      }
      scope.querySelectorAll('.floral-rise').forEach((el) => {
        if (el.classList.contains('is-inview')) return;
        if (el.closest('[data-carousel-track]')) return;
        if (isUnobservable(el)) {
          reveal(el);
          return;
        }
        el.style.willChange = 'opacity, transform';
        observer.observe(el);
      });
    }

    function initReveal() {
      tagLegacyRises(document);
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            observer.unobserve(el);
            if (el.tagName === 'FLORAL-CAROUSEL') {
              el.classList.add('is-inview');
              el.querySelectorAll('[data-carousel-track] > .floral-rise').forEach((cell) => {
                cell.classList.add('is-inview');
                const clearCell = (event) => {
                  if (event.target !== cell) return;
                  cell.style.willChange = '';
                  cell.removeEventListener('transitionend', clearCell);
                };
                cell.addEventListener('transitionend', clearCell);
              });
              return;
            }
            el.classList.add('is-inview');
            const clear = (event) => {
              if (event.target !== el) return;
              el.style.willChange = '';
              el.removeEventListener('transitionend', clear);
            };
            el.addEventListener('transitionend', clear);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
      );
      assignStagger(document);
      observeRises(document);
      const productGrid = document.getElementById('product-grid');
      if (productGrid && window.MutationObserver) {
        const gridObserver = new MutationObserver(() => {
          tagLegacyRises(productGrid);
          assignStagger(productGrid);
          observeRises(productGrid);
        });
        gridObserver.observe(productGrid, { childList: true });
      }
      clearTimeout(failsafe);
    }

    function clearParallaxTransforms() {
      parallaxNodes.forEach((node) => {
        node.el.style.transform = '';
        node.last = null;
      });
    }

    function updateParallaxActive() {
      const next = desktopMq.matches && !prefersReduce();
      if (next === parallaxActive) return;
      parallaxActive = next;
      if (!next) clearParallaxTransforms();
    }

    function measureParallax() {
      parallaxNodes = Array.from(document.querySelectorAll('[data-floral-parallax]')).map((el) => {
        const prev = el.style.transform;
        el.style.transform = 'none';
        const rect = el.getBoundingClientRect();
        const node = {
          el,
          speed: parseFloat(el.getAttribute('data-floral-parallax')) || 0.12,
          center: rect.top + window.scrollY + rect.height / 2,
          last: null
        };
        el.style.transform = prev;
        return node;
      });
    }

    function applyParallax(scroll) {
      if (!parallaxActive) return;
      const mid = scroll + window.innerHeight / 2;
      for (const node of parallaxNodes) {
        const y = clamp((node.center - mid) * node.speed, -parallaxClamp, parallaxClamp);
        const rounded = Math.round(y * 100) / 100;
        if (rounded === node.last) continue;
        node.last = rounded;
        node.el.style.transform = 'translate3d(0,' + rounded + 'px,0)';
      }
    }

    function scheduleMeasure() {
      clearTimeout(measureTimer);
      measureTimer = setTimeout(function () {
        measureParallax();
      }, 150);
    }

    function bindParallaxImages(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-floral-parallax] img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', scheduleMeasure);
      });
    }

    function headerOffset() {
      const header = document.querySelector(
        '#shopify-section-header, .shopify-section-group-header-group, header.header, [data-header-sticky]'
      );
      return header ? -Math.round(header.getBoundingClientRect().height) : 0;
    }

    function scrollWithLenis(target) {
      if (!lenis) return;
      if (target === 0) {
        lenis.scrollTo(0);
        return;
      }
      lenis.scrollTo(target, { offset: headerOffset() });
    }

    function isToggleAnchor(link) {
      return (
        link.matches('[data-toggle], [aria-controls], [role="tab"], .disabled-anchor') ||
        Boolean(link.closest('[data-floral-no-anchor]'))
      );
    }

    function initAnchors() {
      document.addEventListener(
        'click',
        (event) => {
          if (!lenis) return;

          const wrap = event.target.closest('.progress-wrap');
          if (wrap) {
            event.preventDefault();
            event.stopImmediatePropagation();
            scrollWithLenis(0);
            return;
          }

          const link = event.target.closest('a[href^="#"]');
          if (!link) return;

          const href = link.getAttribute('href');
          if (!href || href.length <= 1) return;
          if (isToggleAnchor(link)) return;

          let target;
          try {
            target = document.querySelector(href);
          } catch (err) {
            return;
          }
          if (!target) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          scrollWithLenis(target);
        },
        true
      );
    }

    // Deliberate: theme.js still calls $('html, body').animate({ scrollTop }) from
    // gallery thumbs, cart actions, filters, pagination, and back-to-top. Routing
    // only that case through Lenis keeps a single scroll authority without editing
    // the vendor file. Never installed when Lenis is off.
    function neutralizeLegacyScroll() {
      const $ = window.jQuery;
      if (!$ || !lenis || $.fn.__floralScrollPatched) return;
      const original = $.fn.animate;
      $.fn.animate = function (props, ...rest) {
        if (props && 'scrollTop' in props && this.is('html, body')) {
          lenis.scrollTo(props.scrollTop, { duration: 0.6 });
          const done = rest.find((a) => typeof a === 'function');
          if (done) setTimeout(() => done.call(this), 600);
          return this;
        }
        return original.apply(this, [props, ...rest]);
      };
      $.fn.__floralScrollPatched = true;
    }

    function overlaysOpen() {
      return Boolean(
        document.querySelector(
          '.js-mini-cart.active, .cardraw.active, .menu-natur.active, dialog[open], .modal.show'
        )
      );
    }

    function syncOverlayLock() {
      if (!lenis) return;
      const locked = overlaysOpen();
      if (locked === overlayLocked) return;
      overlayLocked = locked;
      if (locked) lenis.stop();
      else lenis.start();
    }

    function observeOverlay(el) {
      if (!el || el.__floralLockObserved) return;
      el.__floralLockObserved = true;
      overlayObserver.observe(el, { attributes: true, attributeFilter: ['class', 'open'] });
    }

    const overlayObserver = new MutationObserver(syncOverlayLock);

    function bindOverlayTargets(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope
        .querySelectorAll('.js-mini-cart, .cardraw, .menu-natur, dialog, .modal')
        .forEach(observeOverlay);
    }

    function initOverlayLock() {
      bindOverlayTargets(document);
      if (overlayLockBound) return;
      overlayLockBound = true;
      document.addEventListener('toggle', syncOverlayLock, true);
      document.addEventListener('close', syncOverlayLock, true);
      const $ = window.jQuery;
      if ($) {
        $(document).on('shown.bs.modal hidden.bs.modal', syncOverlayLock);
      }
    }

    function refreshAos() {
      if (window.AOS && typeof window.AOS.refresh === 'function') {
        window.AOS.refresh();
      }
    }

    function afterThemeReady(fn) {
      requestAnimationFrame(fn);
      if (document.readyState === 'complete') {
        fn();
        return;
      }
      window.addEventListener('load', fn);
    }

    function initLenis() {
      if (typeof window.Lenis !== 'function') return;

      lenis = new window.Lenis({
        lerp: 0.1,
        smoothWheel: true,
        syncTouch: false,
        allowNestedScroll: true,
        prevent: (node) => Boolean(node.closest && node.closest(overlayPrevent))
      });

      html.classList.add('floral-lenis');
      updateParallaxActive();
      measureParallax();
      bindParallaxImages(document);

      const tick = (time) => {
        lenis.raf(time);
        applyParallax(lenis.scroll);
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      window.floralLenis = lenis;

      afterThemeReady(function () {
        neutralizeLegacyScroll();
        initOverlayLock();
        refreshAos();
        syncOverlayLock();
      });

      window.addEventListener('resize', scheduleMeasure);
      desktopMq.addEventListener('change', function () {
        updateParallaxActive();
        measureParallax();
      });
      reduceMotion.addEventListener('change', function () {
        updateParallaxActive();
        if (prefersReduce()) revealAll(document);
      });
    }

    function onEditorEvent(event) {
      const root = event.target;
      tagLegacyRises(root);
      assignStagger(root);
      revealAll(root);
      measureParallax();
      bindParallaxImages(root);
      bindOverlayTargets(root);
      if (observer) observeRises(root);
    }

    function initEditor() {
      document.addEventListener('shopify:section:load', onEditorEvent);
      document.addEventListener('shopify:section:select', onEditorEvent);
      document.addEventListener('shopify:block:select', onEditorEvent);
    }

    if (isDesignMode) {
      html.classList.remove('floral-js');
      revealAll(document);
      clearTimeout(failsafe);
      initEditor();
      return;
    }

    if (prefersReduce()) {
      revealAll(document);
      clearTimeout(failsafe);
      initEditor();
      return;
    }

    if (motionOn) {
      initReveal();
    } else {
      revealAll(document);
      clearTimeout(failsafe);
    }

    if (smoothOn) {
      initLenis();
      initAnchors();
    }

    initEditor();
  } catch (err) {
    clearTimeout(failsafe);
    revealAll(document);
    document.documentElement.classList.remove('floral-js');
  }
})();
